import legacyLogo from "../assets/sjLogos/security-journey-logo.svg";
import atlasLightLogo from "../assets/sjLogos/sj-logo-atlas-light.svg";
import atlasDarkLogo from "../assets/sjLogos/sj-logo-atlas-dark.svg";

export type ThemeName = "sj-legacy" | "atlas-light" | "atlas-dark" | "system";

export interface IThemeConfig {
  name: ThemeName;
  cssPath: string;
  displayName: string;
  logo: string;
  availableModes: string[];
}

export type ThemeList = Record<Exclude<ThemeName, "system">, IThemeConfig>;

export const THEMES: ThemeList = {
  "atlas-light": {
    name: "atlas-light",
    cssPath: "/themes/atlas-light-theme.css",
    displayName: "Atlas Light",
    logo: atlasLightLogo,
    availableModes: ["atlas"],
  },
  "atlas-dark": {
    name: "atlas-dark",
    cssPath: "/themes/atlas-dark-theme.css",
    displayName: "Atlas Dark",
    logo: atlasDarkLogo,
    availableModes: ["atlas"],
  },
  "sj-legacy": {
    name: "sj-legacy",
    cssPath: "/themes/sj-legacy-theme.css",
    displayName: "SJ Legacy",
    logo: legacyLogo,
    availableModes: ["legacy"],
  },
};

export const THEME_NAMES = Object.keys(THEMES) as ThemeName[];
